export const routePaths = {
  main: {
    path: '/',
    backstreetboys: {
      path: '/tributetobackstreetboys'
    },
    event: {
      path: '/event/:eventId',
    },
    login: {
      path: '/login',
      admin: {
        path: '/login/admin/:token'
      }
    },
    verifyUser: {
      path: '/verify-user/:vendorId/:userToken/:vendorToken'
    },
    vendor: {
      path: '/vendor',
      configuration: {
        path: '/vendor/configuration'
      },
      dashboard: {
        path: '/vendor/dashboard',
        discount: {
          path: '/vendor/dashboard/discount'
        },
        payments: {
          path: '/vendor/dashboard/payments'
        },
        challenges: {
          path: '/vendor/dashboard/challenges'
        },
        profile: {
          path: '/vendor/dashboard/profile'
        },
        team: {
          path: '/vendor/dashboard/team'
        },
        settings: {
          path: '/vendor/dashboard/settings'
        }
      }
    },
  }
};
